<script>
export default {
  props: {
    layout: {
      type: Object,
      default: function () {
        return {
          label: 4,
          wrapper: 8
        }
      }
    },
    client: {
      type: String,
      default: ''
    }
  },
  computed: {
    editing() {
      return this.client !== ''
    }
  },
  data() {
    return {
      ips: 1,
      preload: false,
      processing: false,
      item: {}
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
    this.form.getFieldDecorator('ip_keys', {initialValue: [0], preserve: true})
  },
  created() {
    if (this.editing) {
      this.preload = true
      this.getItem()
    }
  },
  methods: {
    removeIp(ipKey) {
      const {form} = this
      const keys = form.getFieldValue('ip_keys')

      if (keys.length === 1) {
        return
      }

      form.setFieldsValue({
        ip_keys: keys.filter(key => key !== ipKey),
      })
    },
    getItem() {
      this.$http.get(this.routeUri('hyperion.client.show', { client_hash: this.client }) + '?q=')
        .then(res => (this.item = res.data))
        .finally(() => this.preload = false)
    },
    addIP() {
      const {form} = this
      const keys = form.getFieldValue('ip_keys')
      const nextKeys = keys.concat(this.ips++)

      form.setFieldsValue({
        ip_keys: nextKeys
      })
    },
    handleSubmit(e) {
      e.preventDefault(e)

      this.form.validateFields((err, formData) => {
        if (!err) {
          this.processing = true

          let promise

          if (this.editing) {
            promise = this.$http.put(this.routeUri('hyperion.client.update', { client_hash: this.client }), formData)
          } else {
            promise = this.$http.post(this.routeUri('hyperion.client.store'), formData)
          }

          promise.then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleResponseError(error.response.data.data))
            .finally(() => this.processing = false)
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Saved!',
        description: 'Data has been successfully saved!'
      })
      setTimeout(() => window.location.href = data.redirect, 2000)
    },
    handleResponseError(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    }
  },
  watch: {
    item: function (value) {
      this.form.getFieldDecorator('name', {initialValue: value.name})
      this.form.getFieldDecorator('username', {initialValue: value.username})
      this.form.getFieldDecorator('email', {initialValue: value.email})
      this.form.getFieldDecorator('phone_number', {initialValue: value.phone_number})
      this.form.getFieldDecorator('callback_url', {initialValue: value.callback_url})
      this.form.getFieldDecorator('merchant_type', {initialValue: value.merchant_type})
      this.form.getFieldDecorator('terminal_identification', {initialValue: value.terminal_identification})
      this.form.getFieldDecorator('card_acceptor_code', {initialValue: value.card_acceptor_code})
      this.form.getFieldDecorator('card_acceptor_name', {initialValue: value.card_acceptor_name})
      this.form.getFieldDecorator('terminal_id_extra', {initialValue: value.terminal_id_extra})

      if (value.ip_addresses !== null && value.ip_addresses.length > 0) {
        let that = this
        value.ip_addresses.map(function (item, index) {
          if (index > 0) {
            that.addIP()
          }

          that.form.getFieldDecorator(`ip_addresses[${index}]`, {initialValue: item})
        })
      }
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="preload" active>
      <a-form :form="form" @submit="handleSubmit">

        <a-divider dashed orientation="left">General Information</a-divider>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: layout.wrapper }" label="Name">
          <a-input placeholder="Client Name" v-decorator="[ 'name', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Phone">
          <a-input placeholder="Phone" v-decorator="[ 'phone_number', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="phone" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Email">
          <a-input placeholder="Email" type="email" v-decorator="[ 'email', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Merchant Type">
          <a-input placeholder="Merchant Type" v-decorator="[ 'merchant_type', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="book" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Terminal Number">
          <a-input placeholder="Terminal Identification Number" v-decorator="[ 'terminal_identification', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="exception" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Acceptor Code">
          <a-input placeholder="Card Acceptor Code" v-decorator="[ 'card_acceptor_code', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="security-scan" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Acceptor Name">
          <a-input placeholder="Card Acceptor Name" v-decorator="[ 'card_acceptor_name', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="file-done" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Terminal ID">
          <a-input placeholder="Terminal ID" v-decorator="[ 'terminal_id_extra', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="monitor" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-divider dashed orientation="left">Credentials</a-divider>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 6 }" label="Username">
          <a-input placeholder="Username" v-decorator="[ 'username', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="safety" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>


        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 6 }" label="Password" v-if="!editing">
          <a-input placeholder="Password" type="password"
                   v-decorator="[ 'password', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 6, offset: layout.label }" v-if="!editing">
          <a-input placeholder="Password Confirmation" type="password"
                   v-decorator="[ 'password_confirmation', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 12 }" label="Callback URL">
          <a-input placeholder="Callback URL" v-decorator="[ 'callback_url' ]">
            <a-icon slot="prefix" type="link" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 6}" label="IP Address">
          <template v-for="(key, index) in form.getFieldValue('ip_keys')">
            <a-form-item :style="{ display: 'inline-block', width: 'calc(100% - 50px)'}">
              <a-input placeholder="0.0.0.0/0" v-decorator="[ `ip_addresses[${key}]` ]" :key="`ip-${key}`">
                <a-icon slot="prefix" type="cluster" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-item>
            <a-button v-if="form.getFieldValue('ip_keys').length > 1"
                      :disabled="form.getFieldValue('ip_keys').length === 1"
                      type="dashed"
                      shape="circle"
                      icon="delete"
                      style="margin-left: 12px"
                      @click="removeIp(key)"/>
          </template>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 6, offset: layout.label}">
          <a-button type="dashed" @click="addIP">
            <a-icon type="plus"/>
            Add IP
          </a-button>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: layout.label}">
          <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit</a-button>
        </a-form-item>
      </a-form>
    </a-skeleton>
  </a-card>
</template>
